// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HhhG","title":"Info_title__W2H1H","selects":"Info_selects__1nCLX","requiredAsterisk":"Info_requiredAsterisk__2pd8i"};